import { render, staticRenderFns } from "./conflictCase.vue?vue&type=template&id=2bcd479b&scoped=true&"
import script from "./conflictCase.vue?vue&type=script&lang=js&"
export * from "./conflictCase.vue?vue&type=script&lang=js&"
import style0 from "./conflictCase.vue?vue&type=style&index=0&id=2bcd479b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcd479b",
  null
  
)

export default component.exports